import { IRealityCheckData } from "../server/data/IRealityCheckData";
import { BaseModel } from "./BaseModel";
import GameModel from "./GameModel";

class RealityCheckModel extends BaseModel<IRealityCheckData>
  implements IRealityCheckData {
  //* SETTINGS *//
  public hardErrors: boolean = false; // block the user to continue playing

  //* LIMITS *//
  public lossLimit: number = 0; // maximum play time in milliseconds
  public timeLimit: number = 0; // maximum lost money in player's currency - in milliseconds

  //* PROPS *//
  public sessionMoneyResult: number = 0; // the total session money result for the player
  public status: "ok" | "error" = "ok"; // the total session money result for the player
  public sessionStartTime: number = new Date().getTime(); // session start time - defaults to now - in milliseconds
  public totalWin: number = 0;
  public totalBet: number = 0;
  public totalResult: number = 0;
  public totalSessionMinutes: number = 0;

  //* INTERNAL *//

  //*? METHODS ?*//

  public milliSecToMin(milliseconds: number) {
    return {
      min: Math.floor(milliseconds / 60000),
      sec: Math.floor((milliseconds % 60000) / 1000)
    };
  }

  public minToMillisec(min: number) {
    return min * 60000;
  }

  public getElapsedTime(): number {
    return new Date().getTime() - this.sessionStartTime;
  }

  public getTimeTillTimeLimit() {
    return this.timeLimit - this.getElapsedTime();
  }

  public performRealityCheck() {
    return this.getTimeTillTimeLimit() < 0;

    // TODO: perform also Loss check
  }
}

export default new RealityCheckModel();
